// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__36v2F","list":"BalanceDue_list__3soSi","listRow":"BalanceDue_listRow__273Kl","total":"BalanceDue_total__dAarV"};